import React from 'react';
import styles from "../../../styles/ai/papers/AIPapers.module.css";

import AIPaperSection from '../../../components/ai/papers/AIPaperSection';

const AIPapers = () => {
  return (
    <>
      <AIPaperSection styles={styles} />
    </>
  )
}

export default AIPapers